import { LOG_IN, LOG_OFF } from '../../actions/types';

const initialState = {

  UserName: "",
  UserDisplayName: "",
  UserRoleType: 0
}
export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_IN:
      return Object.assign({}, state, {
        ...action.payload
      });
    case LOG_OFF:
      return Object.assign({}, {}
      );

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/login/loginReducer.js